import { createApi } from '@reduxjs/toolkit/query/react';

import { AllDataResponseDto, DeleteParamsDto, DeleteStatusDto, PaginatedResponse } from '../common/dto/common.dto';
import { FilterDto } from '../common/dto/filter.dto';
import { LocationCreateDto, LocationUpdateDto, LocationViewDto, UserInLocationViewDto } from '../common/dto/location.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;
const TAG_TYPE = 'Location';

type ChildrenLocationParams = {
  locationIds: string[];
};

export const locationApi = createApi({
  reducerPath: 'locationApi',
  baseQuery: customFetchBase(`${API_URI}/api/location`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    searchLocation: builder.mutation<PaginatedResponse<LocationViewDto>, Partial<FilterDto>>({
      query(body) {
        return {
          url: ``,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    getLocation: builder.query<LocationViewDto, string>({
      query: (id: string) => {
        return `${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    updateLocation: builder.mutation<LocationViewDto, Partial<LocationUpdateDto>>({
      query(data) {
        return {
          url: ``,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    addLocation: builder.mutation<LocationViewDto, Partial<LocationCreateDto>>({
      query(body) {
        return {
          url: ``,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),

    deleteLocation: builder.mutation<DeleteStatusDto, DeleteParamsDto>({
      query(data: DeleteParamsDto) {
        return {
          url: data.id,
          method: 'DELETE',
          body: data.params ?? {},
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),

    getUsersInLocation: builder.query<AllDataResponseDto<UserInLocationViewDto>, string>({
      query(locationId: string) {
        return {
          url: `${locationId}/users`,
        };
      },
    }),
    searchChildrenLocation: builder.mutation<PaginatedResponse<LocationViewDto>, ChildrenLocationParams>({
      query(body) {
        return {
          url: 'get-child-locations',
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const {
  useSearchLocationMutation,
  useGetLocationQuery,
  useUpdateLocationMutation,
  useAddLocationMutation,
  useDeleteLocationMutation,
  useLazyGetUsersInLocationQuery,
  useSearchChildrenLocationMutation,
} = locationApi;
